(() => {
    class CollectionFilter extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', this.checkIfSliderNeeded);
        this.checkUrl();
        window.addEventListener('resize', this.checkIfSliderNeeded);
      }
  
      checkIfSliderNeeded() {
        const container = document.querySelector('.subcollection-list-container');
        const wrapper = document.querySelector('.subcollection-list__wrapper');
        const navButtons = document.querySelectorAll('.nav-buttons');
      
        if (wrapper.scrollWidth > container.clientWidth) {
            navButtons.forEach(button => {
                button.classList.remove('hide');
            })
            container.classList.add('hide');
            wrapper.classList.add('active');

           const swiper =  new Swiper('.subcollection-list', {
                slidesPerView: "auto",
                slidesPerGroupAuto: true,
                a11y: false,
                // slidesOffsetAfter: 100,
                spaceBetween: 8,
                allowTouchMove: true, 
                simulateTouch: false,
                initialSlide: 0,
                navigation: {
                    nextEl: '.filter-btn-next',
                    prevEl: '.filter-btn-prev',
                },
                breakpoints: {
                  768: {
                    // slidesOffsetAfter: 10,
                    spaceBetween: 16,
                  }
                }
              });
        
        } else {  
            navButtons.forEach(button => {
                button.classList.add('hide');
            })
            container.classList.remove('hide');
            wrapper.style.transform = 'none!important';
            wrapper.classList.remove('active');
        }
      }
      checkUrl(){
        const pathName = window.location.pathname;
        const items = document.querySelectorAll('.subcollection-list__item');
        items?.forEach(item => {
          const itemLink = item.querySelector('a');
          if (pathName == itemLink.pathname ){
            item.classList.add('active')
          }
        })
      }
  
    }
  
  customElements.define("collection-filter", CollectionFilter);
  })();